import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment'
import Button from '../../Button';
import DateField from './DateField'

class ModalConfirm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: moment().utc().format("YYYY-MM-DD"),
            submitting: false,
            terminateEffectiveDate: false
        }
    }

    async handleClick(e) {
        const { terminateEffectiveDate } = this.state;
        if (typeof this.props.onSubmit !== 'undefined') {
            this.setState({ submitting: true })
            await this.props.onSubmit(
                terminateEffectiveDate ? this.props.minDate : this.state.date
            ).catch(error => console.log(error));
            this.setState({ submitting: false })
        }
    }

    handleCancelClick(e) {
        if (typeof this.props.cancel !== 'undefined') {
            if (typeof this.props.cancel.onClick === 'function') {
                this.props.cancel.onClick(e);
            } else {
                this.context.showModal(false);
            }
        } else {
            this.context.showModal(false);
        }
    }


    render() {
        const { terminateEffectiveDate } = this.state;

        return (
            <div className="modal-terminate">
                <div onClick={this.handleCancelClick.bind(this)} className="close"><i className="material-icons">close</i></div>
                <div className={'center'}>
                    <h4>Are you sure you want to terminate?</h4>
                    <p>If you would like to set the termination date, change the field below <br />(Termination Date can not precede Coverage Effective Date).</p>
                </div>
                <DateField
                    label="Set Termination Date"
                    type="date"
                    value={terminateEffectiveDate ? this.props.minDate : this.state.date}
                    valid={true}
                    disabled={terminateEffectiveDate}
                    inputProps={{
                        min: this.props.minDate,
                        max: this.props.maxDate
                    }}
                    onChange={(e, field) => this.setState({ date: field.value })}
                />
                <div className={'terminate-effective'}>
                    <input
                        type="checkbox"
                        id="terminate-effective"
                        name="terminate-effective"
                        checked={terminateEffectiveDate}
                        onChange={(e) => {
                            this.setState({ terminateEffectiveDate: e.target.checked })
                        }}
                    />
                    <label
                        className="checkbox-label"
                        htmlFor="terminate-effective"
                    >
                        Close out patient record and set Coverage Termination Date to the Coverage Effective Date {this.props.minDate}
                    </label>
                </div>
                <div className={'center'}>
                    <Button
                        flat={true}
                        onClick={this.handleClick.bind(this)}
                        disabled={this.state.submitting}>
                        Confirm Termination
                    </Button>
                </div>
            </div>
        );
    }
}

ModalConfirm.contextTypes = {
    showModal: PropTypes.func
};

export default ModalConfirm;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalTerminate/ModalTerminate.js